


















import { defineComponent } from '@vue/composition-api';
import { container } from 'tsyringe';

import FullAudioPlayer from './FullAudioPlayer.vue';
import CompactAudioPlayer from './CompactAudioPlayer.vue';
import VinylPostcardsAudioPlayer from './VinylPostcardsAudioPlayer.vue';
import { ModelManager } from '../model';

type AudioPlayerComponents = 'CompactAudioPlayer' | 'FullAudioPlayer' | 'VinylPostcardsAudioPlayer';

// I guess this is how typescript props suppport with the composition api should be done (at least until the new SFC syntax is used)
// though no type checking with vetur (yet: https://github.com/vuejs/vetur/issues/1596)
type Props = {
  modelId: string;
  component: AudioPlayerComponents;
  compact: boolean;
};

export default defineComponent<Props>({
  name: 'AudioPlayerContainer',
  props: {
    modelId: { type: String, default: 'audio-player' },
    component: { type: String, default: 'VinylPostcardsAudioPlayer' as const },
    compact: { type: Boolean, default: false },
  },
  components: {
    CompactAudioPlayer,
    FullAudioPlayer,
    VinylPostcardsAudioPlayer,
  },
  setup(props) {
    const modelManager = container.resolve(ModelManager);
    const audioPlayer = modelManager.get(props.modelId, 'AudioPlayerModel');
    const audioLib = modelManager.get('audio-lib', 'StoryblokAudioLibModel');

    // Uncomment to fill library with pre-unlocked audio tracks

    // const vinylpostcards = modelManager.get('vinylpostcards', 'VinylPostcardsModel');
    // const imageTargetTracks = modelManager.get('image-target-tracks', 'StoryblokImageTargetTracksLibModel');

    // const pollAudioLib = () => {
    //   if (audioLib.state.audioLib.length === 0 || imageTargetTracks.state.imageTargetTracks.length === 0) {
    //     setTimeout(pollAudioLib, 100)
    //   } else {
    //     [
    //       "Kentrix_-_The_Love_we_share_front",
    //       "002 - AnyMF_NoWay_Front_A6_300_148x105_rz",
    //       "Abria_VPC_A6_148x105_Front_rz_WEB1",
    //       "006 - BLD_VPC_A6_148x105_Front_rz_best",
    //       "V01.011"
    //     ]
    //     .forEach(n => vinylpostcards.stopAudioPlayerAndAddNewSongsFromImageTarget(n, audioPlayer, audioLib, imageTargetTracks));
      // }
    // };
    // pollAudioLib();

    return {
      audioInfo: audioLib.getAudioTrackInfo(audioPlayer.currentAudioTrack),
      audioPlayer,
    };
  },
});
